import { Component } from '@angular/core';

import { PagePlaceholderComponent } from '../../../core/components/page-placeholder/page-placeholder.component';

@Component({
  selector: 'app-prayer-times',
  imports: [PagePlaceholderComponent],
  templateUrl: './prayer-times.component.html',
  styleUrl: './prayer-times.component.scss'
})
export class PrayerTimesComponent {
  protected readonly icon = '🕐';
  protected readonly pageTitle = 'pages.prayer_times.title';
  protected readonly subtitle = 'pages.prayer_times.subtitle';
}
